import _ from 'lodash';
import { StoreType } from '../../../../enuns/store.enun';
import { translate, translateText } from '../../../../scripts/core/tools/translate';
import environment from '../../../../scripts/environment';
import api from '../../../../scripts/api';
import { FeaturePermission } from '../../../../constants/feature.permission.helper';
const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

export class CustomersFilterFactory {
    constructor ({ options, currentMap }) {
        this.options = options;
        this.currentMap = currentMap;
    }

    getData () {
        const data = [];
        const dataSource = _(environment.get('CONFIG.FILTERS.DEALERS_STORES'))
            .filter(val => !_.some([StoreType.TwoS], t => val.Tipo.toUpperCase() === t.toUpperCase()))
            .map(val => ({
                dealerName: val.Nome,
                dealerId: val.Id,
                groupName: val.Grupo,
                groupId: val.Grupo,
                stateName: val.UF,
                stateId: val.UF,
                groupClientName: val.GrupoCliente,
                groupClientId: val.GrupoCliente,
            }))
            .orderBy(val => val.text)
            .value();

        data.push({
            name: 'dealers_groups',
            position: 1,
            data: dataSource,
            fields: [{
                title: translate('Common.State'),
                name: 'states',
                value: 'stateId',
                text: 'stateName',
                type: 'multiselect',
                required: true,
                visible: isAuthorized(FeaturePermission.LAYER_CUSTOMER.filterUf)
            }, {
                title: translate('Common.Groups'),
                name: 'groups',
                value: 'groupId',
                text: 'groupName',
                type: 'multiselect',
                visible: isAuthorized(FeaturePermission.LAYER_CUSTOMER.filterGroup)
            },
            ...(isAuthorized(FeaturePermission.LAYER_CUSTOMER.showGroupClient)
                ? [{
                    title: `${translate('Common.Group')} ${translate('Common.Client')}`,
                    name: 'groupClient',
                    value: 'groupClientId',
                    text: 'groupClientName',
                    type: 'multiselect',
                    visible: isAuthorized(FeaturePermission.LAYER_CUSTOMER.showGroupClient)
                }]
                : []),
            {
                title: translate('Common.Dealer'),
                name: 'dealers',
                value: 'dealerId',
                text: 'dealerName',
                type: 'multiselect',
                visible: isAuthorized(FeaturePermission.LAYER_CUSTOMER.filterDealer)
            },
            ]
        });

        if (this.options.fields.fuelTypes) {
            data.push({
                name: 'fuelTypes',
                position: 5,
                visible: isAuthorized(FeaturePermission.LAYER_CUSTOMER.filterFuelType),
                fields: [{
                  title: translate('Common.FuelType'),
                  name: 'fuelTypes',
                  dataSource: _.map(environment.get('CONFIG.FILTERS.FUEL_TYPES'), (fuel) => ({ text: fuel.text, value: fuel.value })),
                  value: 'value',
                  text: 'text',
                  skipAll: true,
                  type: 'multiselect',
                  visible: isAuthorized(FeaturePermission.LAYER_CUSTOMER.filterFuelType),
                }]
            });
        }

        if (this.options.fields.segments) {
            data.push({
                name: 'segments',
                data: _.reduce(environment.get('CONFIG.FILTERS.COMPETING_SEGMENTS'), (acc, val, key) => {
                    _.forEach(val, (v) => {
                        acc.push({
                            CD_CAT: key,
                            NM_CAT: key === 'competing' ? 'Competing' : 'Non Competing',
                            CD_SEGMENT: v.id,
                            NM_SEGMENT: translateText(v.nome, true)
                        });
                    });

                    return acc;
                }, []),
                position: 2,
                visible: isAuthorized(FeaturePermission.LAYER_CUSTOMER.filterSegment),
                fields: [{
                    title: `${translate('Common.Classification')} ${translate('Common.Segment')}`,
                    name: 'competingClassification',
                    value: 'CD_CAT',
                    text: 'NM_CAT',
                    skipAll: true,
                    type: 'multiselect',
                    visible: isAuthorized(FeaturePermission.LAYER_CUSTOMER.filterSegment),
                }, {
                    title: translate('Common.Segments'),
                    name: 'segments',
                    value: 'CD_SEGMENT',
                    text: 'NM_SEGMENT',
                    group: 'NM_CAT',
                    type: 'multiselect',
                    skipAll: true,
                    visible: isAuthorized(FeaturePermission.LAYER_CUSTOMER.filterSegment),
                }]
            });
        }

        if (this.options.fields.saleType) {
            data.push({
                name: 'saleType',
                position: 3,
                visible: isAuthorized(FeaturePermission.LAYER_CUSTOMER.filterSaleType),
                fields: [{
                    title: translate('Common.Type'),
                    name: 'saleType',
                    dataSource: environment.get('CONFIG.FILTERS.SALES_TYPE'),
                    value: 'value',
                    text: 'text',
                    type: 'dropdown',
                    index: 0,
                    noPlaceholder: true,
                    visible: isAuthorized(FeaturePermission.LAYER_CUSTOMER.filterSaleType),
                }]
            });
        }

        data.forEach(d=> d.fields = d.fields.filter(c => c.visible));
        return data;
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/customers.factory.js